import type { SVGProps } from 'react';

const SvgExperiences = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="experiences">
      <path d="M25.22 15.43a3.28 3.28 0 0 0 2.37 3.13 12 12 0 0 1-22 3.32l-1.28.77a13.54 13.54 0 0 0 24.84-4 3.27 3.27 0 1 0-3.9-3.2Zm3.27-1.77a1.77 1.77 0 1 1-1.77 1.77 1.77 1.77 0 0 1 1.77-1.77ZM3.51 18.7a3.26 3.26 0 0 0 1-6.37A12 12 0 0 1 26.47 9l1.28-.79a13.54 13.54 0 0 0-24.75 4 3.26 3.26 0 0 0 .5 6.49Zm0-5a1.77 1.77 0 1 1-1.77 1.77 1.77 1.77 0 0 1 1.77-1.81Z" />
      <path d="M23.25 15.43A7.25 7.25 0 1 0 16 22.68a7.26 7.26 0 0 0 7.25-7.25Zm-13 0A5.75 5.75 0 1 1 16 21.18a5.76 5.76 0 0 1-5.75-5.75Z" />
    </g>
  </svg>
);

export default SvgExperiences;
